import { SubmitHandler } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import adaptCreateBanner from "src/features/HomepageCarouselBanners/adapters/adaptCreateBanner";
import CreateBannerForm from "src/features/vendorSponsorshipAdmin/components/CreateBannerForm/CreateBannerForm";
import VENDOR_FULL_PAGE_TAKEOVER_FORM from "../../constants/vendorStepsForm";
import useCreateFullScreenTakeover from "../../hooks/useCreateFullScreenTakeover/useCreateFullScreenTakeover";

const CreateFullScreenTakeover = () => {
	const navigate = useNavigate();

	const defaultValues: BannerFormState & { audienceGroupIds?: number[] } = {
		bannerStyle: "standard",
		bannerType: "fullScreenTakeoverBanner",
		selectedHashtag: null,
		feedId: null,
		steps: VENDOR_FULL_PAGE_TAKEOVER_FORM,
		audienceGroupIds: [],
		buttonLink: "",
		openInBrowser: false,
		linkFeedId: null,
		selectedLinkFeed: null
	};

	const { mutate: createFullScreenTakeoverBanner } =
		useCreateFullScreenTakeover();

	const onSuccess = () => {
		toast.success(<CustomToast type="Success" message="Saved Successfully" />);
		navigate(
			"/vendor-sponsorship/full-screen-takeover/banners?published=false"
		);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="There is an error creating the form" />
		);
	};

	const onSubmit: SubmitHandler<BannerFormState> = (data) => {
		console.log("FORM IS VALID, SUBMIT FORM", data);

		const audienceGroupIds = (
			data as BannerFormState & {
				audienceGroupIds?: number[];
			}
		).audienceGroupIds;

		createFullScreenTakeoverBanner(
			{
				...adaptCreateBanner(data),
				audience_group_ids: audienceGroupIds ?? []
			} as Omit<CarouselBanner, "id"> & { audience_group_ids: number[] },
			{
				onSuccess,
				onError
			}
		);
	};

	return (
		<CreateBannerForm
			onSubmit={onSubmit}
			defaultValues={defaultValues}
			bannerTypeRadioOptions={["fullScreenTakeoverBanner"]}
			showBannerTypePicker={false}
			showAudienceGroups
			root="full-screen-takeover"
		/>
	);
};

export default CreateFullScreenTakeover;
